/**
 * Editor de **precio de doblez por calibre** (`precios_dobles`, Sección 2).
 *
 * Lista dinámica: una fila por calibre (`label : input × `) con "+ Calibre" para
 * añadir (autogenera el siguiente par, réplica del SSR) y `×` por fila para
 * quitar. Presentacional: el estado lo posee `PreciosForm`; este componente solo
 * pinta y notifica cambios. Sin `fetch` ni lógica de datos.
 */
import { Button, Input } from "@/components/ui";

import { nextCalibre, type DoblesRow } from "../precios.transform";

interface DoblesCalibresEditorProps {
  rows: DoblesRow[];
  onChange: (rows: DoblesRow[]) => void;
}

export function DoblesCalibresEditor({ rows, onChange }: DoblesCalibresEditorProps) {
  function setValor(index: number, valor: string) {
    onChange(rows.map((row, i) => (i === index ? { ...row, valor } : row)));
  }

  function addCalibre() {
    onChange([...rows, { calibre: nextCalibre(rows), valor: "" }]);
  }

  function removeCalibre(index: number) {
    onChange(rows.filter((_, i) => i !== index));
  }

  return (
    <div className="flex flex-col gap-2">
      <span className="text-sm font-medium text-slate-700">
        Precio doblez por calibre
      </span>
      {rows.length === 0 ? (
        <p className="text-sm text-slate-500">Sin calibres. Añade uno.</p>
      ) : (
        <ul className="flex flex-col gap-2">
          {rows.map((row, index) => {
            const inputId = `dobles-calibre-${row.calibre}`;
            return (
              <li key={`${row.calibre}-${index}`} className="flex items-center gap-2">
                <label
                  htmlFor={inputId}
                  className="w-16 shrink-0 text-sm text-slate-600"
                >
                  Cal. {row.calibre}
                </label>
                <Input
                  id={inputId}
                  type="number"
                  step="0.01"
                  inputMode="decimal"
                  value={row.valor}
                  onChange={(event) => setValor(index, event.target.value)}
                />
                <Button
                  type="button"
                  variant="ghost"
                  size="sm"
                  aria-label={`Quitar calibre ${row.calibre}`}
                  onClick={() => removeCalibre(index)}
                >
                  ×
                </Button>
              </li>
            );
          })}
        </ul>
      )}
      <div>
        <Button type="button" variant="secondary" size="sm" onClick={addCalibre}>
          + Calibre
        </Button>
      </div>
    </div>
  );
}
